import styled from 'styled-components';

export const NewStudentRegisterWrapper = styled.div`
  .new-student-register {
  }

  .ant-picker.ant-picker-outlined {
  }
`;

export const NewStudentRegisterStyled = styled.div`
  .ant-picker.ant-picker-outlined {
    width: 400px !important;
  }
`;

export const ErrorMessage = styled.div`
  width: max-content;
  height: ${(props) => (props.message ? '20px' : '0px')};
  color: #ff4d4f;
`;
